import React from "react";
import { ContactSection } from "./Landing";
import HomeLayout from "../layouts/home";
import { useTranslation } from "../contexts/I18nProvider";

function Contact() {
  const { t } = useTranslation();
  
  return (
    <HomeLayout>
      <ContactSection noImage />
    </HomeLayout>
  );
}

export default Contact;
